import {css, jsx} from '@emotion/react';
import styled from '@emotion/styled';

export const Description = styled('p')({color: 'black'});
